import React, { useEffect, useState } from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import axiosConn from 'config/axiosConn';

const BarCharts = ({ state }) => {
  // Get the current year dynamically
  const currentYear = new Date().getFullYear();
  const previousYear = currentYear - 1;

  const [chartData, setChartData] = useState({
    DigitalCount: [],
    PhysicalCount: []
  });
  const [selectedYear, setSelectedYear] = useState(currentYear.toString());  // Default to the current year

  const xLabels = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  // Function to fetch data based on the selected year
  const fetchYearData = async (year) => {
    console.log('Year:----------------------', year);
    try {
      const response = await fetch(`https://ecoclubs.education.gov.in/api/get-events-by-year`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ year }),
      });

      const data = await response.json();

      console.log('Response data:-----------', data);

      if (data.status === 'success') {
        setChartData(prevChartData => ({
          ...prevChartData,
          DigitalCount: data.result.digitalCountArray ?? [],
          PhysicalCount: data.result.physicalCountArray ?? [],
        }));
      }
    } catch (error) {
      console.error('Error fetching year data:', error);
    }
  };

  // Function to fetch data based on the state name
  const fetchStateData = async (state) => {
    try {
      const response = await fetch('https://ecoclubs.education.gov.in/api/get-counts-by-state', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ state }),
      });
  
      const data = await response.json();
  
      if (response.ok && data?.result) {
        setChartData(prevChartData => ({
          ...prevChartData,
          DigitalCount: data.result.digitalCountArray ?? [],
          PhysicalCount: data.result.physicalCountArray ?? [],
        }));
      } else {
        console.error('Failed to fetch state data:', data);
      }
    } catch (error) {
      console.error('Error fetching state data:', error);
    }
  };
  
  

  // Fetch data when the component is mounted or when state or selectedYear changes
  useEffect(() => {
    if (state) {
      // If state is provided, fetch data for the selected state
      fetchStateData(state);
    } else {
      // If no state, fetch data for the selected year
      fetchYearData(selectedYear);
    }
  }, [selectedYear, state]); // Dependency array ensures it re-runs if selectedYear or state changes

  return (
    <>
      <h5 className="bold-text">
        Total no. of events held - Current Academic Year
      </h5>
      {/* Buttons to toggle between Current Year and Previous Year */}
      <div className="year-selector">
        <button 
          onClick={() => setSelectedYear(currentYear.toString())}
          className={selectedYear === currentYear.toString() ? 'active' : ''}
        >
          Current Year
        </button>
        <button 
          onClick={() => setSelectedYear(previousYear.toString())}
          className={selectedYear === previousYear.toString() ? 'active' : ''}
        >
          Previous Year
        </button>
      </div>
      
      <div className="totalnumber">
        <BarChart
          width={700}
          height={340}
          series={[
            { data: chartData.DigitalCount, label: 'Digital Count', id: 'pvId' },
            { data: chartData.PhysicalCount, label: 'Physical Count', id: 'uvId' },
          ]}
          xAxis={[{ data: xLabels, scaleType: 'band' }]}
        />
      </div>
    </>
  );
}

export default BarCharts;
